module.exports = __webpack_public_path__ + "3c5ba0c4f19b3454d5f5ea2329c018c6.pdf";